import {
  useCallback,
  useState
} from "react";
import { TabsItem } from "@/app/components/Tabs";

interface IUseTabsProps {
  defaultActiveKey?: string;
  items: TabsItem[];
}

export const useTabs = ({ defaultActiveKey, items }: IUseTabsProps) => {
  const [activeTab, setActiveTab] = useState<string>(defaultActiveKey || items[0]?.key || "");

  const handleTabChange = useCallback((key: string): void => {
    setActiveTab(key);
  }, []);

  return {
    activeTab,
    handleTabChange,
    items
  };
};